/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, Input } from '@angular/core';
import {
  AbstractControl,
  AsyncValidator,
  AsyncValidatorFn,
  NG_ASYNC_VALIDATORS,
  ValidationErrors
} from '@angular/forms';
import { ErrorModel, ErrorSeverityEnum } from '@irian-ro/shared-components-module';
import { Observable, of } from 'rxjs';
import { DistanceResourceService } from '@well/resource-services';
import { map } from 'rxjs/operators';
import { DistanceStatusDtoModel } from '@well/domain';
import { PointDtoModel } from '@well/address-management-domain-model';


@Directive({
  selector: '[wellDistanceAsync]',
  providers: [{provide: NG_ASYNC_VALIDATORS, useExisting: DistanceAsyncValidator, multi: true}]
})
export class DistanceAsyncValidator implements AsyncValidator {

  @Input('wellDistanceAsync') value: PointDtoModel[] | undefined = undefined;

  constructor(private distanceResourceService: DistanceResourceService) {
  }

  validate(control: AbstractControl) {

    const funcProperties = {
      value: this.value,
      distanceResourceService: this.distanceResourceService
    };
    return _distanceAsyncValidation.bind(funcProperties)(control);
  }
}

export const distanceAsyncValidation = (value: PointDtoModel[], distanceResourceService: any): AsyncValidatorFn => {

  const funcProperties = {
    value: value,
    distanceResourceService: distanceResourceService
  };

  return _distanceAsyncValidation.bind(funcProperties);
};

function _distanceAsyncValidation(this: any, control: AbstractControl): Observable<ValidationErrors | null> {

  let errors: ErrorModel | null = null;

  const pointDTO = control.value?.address?.pointDTO;
  if (pointDTO) {
    const controlValuePoint = new PointDtoModel();
    controlValuePoint.longitude = pointDTO.longitude;
    controlValuePoint.latitude = pointDTO.latitude;

    return this.distanceResourceService.arePointAndLineWithin(controlValuePoint, this.value).pipe(
      map((res: DistanceStatusDtoModel) => {
        if (res.distanceStatus === false) {
          errors = {
            severity: ErrorSeverityEnum.error,
            message: 'maxDistanceExceeded'
          };

        }
        return errors ? errors : null;
      })
    );
  }
  return  of(null);
}
